<script lang="ts">
  import FeatherIcon  from "svelte-feather-icon";
  import Link from "svelte-link";
  import { href } from "../../../utils/Constant/Constant";
  import {newBookmarkAdd,open,editBookmark} from "../../../store"
  type filterdata= {
        img: string;
        id: string;
        header: string;
        fillstar: boolean;
        link: string;
        content: string;
        title: string;
        class: string;
        class2: string;
    }[]
    export let bookmarkItem:any
    let setNewBookmarkAdd:filterdata
    newBookmarkAdd.subscribe((value)=>{
        setNewBookmarkAdd = value
    })
    const RemoveItem = (data:any) => {
        newBookmarkAdd.update(value => value = setNewBookmarkAdd.filter((ele)=> ele.id !== data.id ))
    }
    let setEditBookmark
    editBookmark.subscribe((value)=>{
        setEditBookmark = value
    })
    const handleIcon = (selectvalue) => {
        let newValue = {
            weburl : selectvalue.link,
            titles : selectvalue.header,
            description : selectvalue.content,
            getId : selectvalue.id
        }
        editBookmark.update((value)=> value = newValue  )
        open.update(value => value = !value)
    }
</script>
<div class="title-bookmark">
    <h6 class="title_0">{bookmarkItem.header}</h6>
    <p class="weburl_0">{bookmarkItem.link}</p>
    <div class="hover-block">
        <ul>
            <li>
                <Link href={href} on:click={()=>handleIcon(bookmarkItem)}>
                    <FeatherIcon icon="edit-2" />
                </Link>
            </li>
            <li><Link href={href}><FeatherIcon icon="link"/></Link></li>
            <li><Link href={href}><FeatherIcon icon="share-2"/></Link></li>
            <li>
                <Link href={href} on:click={()=>RemoveItem(bookmarkItem)}>
                    <FeatherIcon icon="trash-2"/>
                </Link>
            </li>
            <li class="pull-right text-end">
                <Link href={href}>
                    <FeatherIcon icon="tag"/>
                </Link>
            </li>
        </ul>
    </div>
    <div class="content-general">
        <p class="desc_0">{bookmarkItem.content}</p>
        <span class={bookmarkItem.class}>{bookmarkItem.title}</span>
    </div>
</div>